import { render, staticRenderFns } from "./BStep.vue?vue&type=template&id=3f7c462c&"
import script from "./BStep.vue?vue&type=script&lang=js&"
export * from "./BStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports